export const CUSTOMIZER_DATA = [
  {
    path: "https://support.pixelstrap.com/",
    icon: "icon-support",
    name: "Support",
  },
  {
    path: "https://docs.pixelstrap.net/react/boho/document/",
    icon: "icon-settings",
    name: "Document",
  },
  {
    path: "https://landing.pixelstrap.net/react/boho/template/landing-page.html",
    icon: "icon-panel",
    name: "Check Features",
  },
  {
    path: "https://themeforest.net/user/pixelstrap/portfolio",
    icon: "icon-shopping-cart-full",
    name: "Buy Now",
  },
];